// REGERA site content — single source of truth for services, industries,
// innovation, metamorphosis, navigation and imagery. CMS-ready structure.

export const NAV = [
  { label: "HOME", to: "/" },
  { label: "ABOUT", to: "/about" },
  { label: "SERVICES", to: "/services" },
  { label: "INDUSTRIES", to: "/industries" },
  { label: "TRANSFORMATION", to: "/portfolio" },
  { label: "METAMORPHOSIS", to: "/metamorphosis" },
  { label: "INNOVATION", to: "/innovation" },
  { label: "INSIGHTS", to: "/insights" },
  { label: "CONTACT", to: "/contact" },
];

export const IMAGES = {
  heroArch:
    "https://images.unsplash.com/photo-1531591022136-eb8b0da1e6d0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMG1vZGVybiUyMGFyY2hpdGVjdHVyZSUyMGdlb21ldHJpY3xlbnwwfHx8fDE3ODc3NjA5NTl8MA&ixlib=rb-4.1.0&q=85",
  boardroom:
    "https://images.unsplash.com/photo-1779700210487-a01758a3c55a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxleGVjdXRpdmUlMjBib2FyZHJvb20lMjBjb3Jwb3JhdGUlMjBza3lsaW5lfGVufDB8fHx8MTc4Nzc2MTI3OXww&ixlib=rb-4.1.0&q=85",
  dataCenter:
    "https://images.unsplash.com/photo-1762163516269-3c143e04175c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwyfHxkYXRhJTIwY2VudGVyJTIwdGVjaG5vbG9neSUyMGluZnJhc3RydWN0dXJlfGVufDB8fHx8MTc4Nzc2MTI3OXww&ixlib=rb-4.1.0&q=85",
  cabling:
    "https://images.unsplash.com/photo-1783683783819-e6cb806bba69?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHw0fHxkYXRhJTIwY2VudGVyJTIwdGVjaG5vbG9neSUyMGluZnJhc3RydWN0dXJlfGVufDB8fHx8MTc4Nzc2MTI3OXww&ixlib=rb-4.1.0&q=85",
  refinery:
    "https://images.unsplash.com/photo-1588011930968-eadac80e6a5a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHxpbmR1c3RyaWFsJTIwaW5mcmFzdHJ1Y3R1cmUlMjBvaWwlMjBnYXMlMjBlbmVyZ3l8ZW58MHx8fHwxNzg3NzYxMjc5fDA&ixlib=rb-4.1.0&q=85",
  refinery2:
    "https://images.unsplash.com/photo-1509390288171-ce2088f7d08e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwzfHxpbmR1c3RyaWFsJTIwaW5mcmFzdHJ1Y3R1cmUlMjBvaWwlMjBnYXMlMjBlbmVyZ3l8ZW58MHx8fHwxNzg3NzYxMjc5fDA&ixlib=rb-4.1.0&q=85",
  arch1:
    "https://images.unsplash.com/photo-1554708991-6a1a369396db?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHw0fHxhYnN0cmFjdCUyMG1vZGVybiUyMGFyY2hpdGVjdHVyZSUyMGZhY2FkZSUyMGdlb21ldHJpY3xlbnwwfHx8YmxhY2tfYW5kX3doaXRlfDE3ODc3NjEyNzl8MA&ixlib=rb-4.1.0&q=85",
  arch2:
    "https://images.unsplash.com/photo-1544115342-94c7b13d325c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwzfHxhYnN0cmFjdCUyMG1vZGVybiUyMGFyY2hpdGVjdHVyZSUyMGZhY2FkZSUyMGdlb21ldHJpY3xlbnwwfHx8YmxhY2tfYW5kX3doaXRlfDE3ODc3NjEyNzl8MA&ixlib=rb-4.1.0&q=85",
  arch3:
    "https://images.unsplash.com/photo-1509413031665-0d52b03f5cde?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMG1vZGVybiUyMGFyY2hpdGVjdHVyZSUyMGZhY2FkZSUyMGdlb21ldHJpY3xlbnwwfHx8YmxhY2tfYW5kX3doaXRlfDE3ODc3NjEyNzl8MA&ixlib=rb-4.1.0&q=85",
  arch4:
    "https://images.unsplash.com/photo-1649690912363-58e651ddab6c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwyfHxhYnN0cmFjdCUyMG1vZGVybiUyMGFyY2hpdGVjdHVyZSUyMGZhY2FkZSUyMGdlb21ldHJpY3xlbnwwfHx8YmxhY2tfYW5kX3doaXRlfDE3ODc3NjEyNzl8MA&ixlib=rb-4.1.0&q=85",
  archWindows:
    "https://images.unsplash.com/photo-1498262257252-c282316270bc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwzfHxhYnN0cmFjdCUyMG1vZGVybiUyMGFyY2hpdGVjdHVyZSUyMGdlb21ldHJpY3xlbnwwfHx8fDE3ODc3NjA5NTl8MA&ixlib=rb-4.1.0&q=85",
  redFluid:
    "https://images.unsplash.com/photo-1725354282080-cf7e4b7325bc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwzfHxyZWQlMjBhYnN0cmFjdCUyMGZsdWlkJTIwZ2VvbWV0cmljJTIwc2hhcGV8ZW58MHx8fHwxNzg3NzYwOTU5fDA&ixlib=rb-4.1.0&q=85",
  meeting:
    "https://images.unsplash.com/photo-1517048676732-d65bc937f952?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMHRyYW5zZm9ybWF0aW9uJTIwdGVhbSUyMG1lZXRpbmclMjBzdHJhdGVneXxlbnwwfHx8fDE3ODc3NjEyNzl8MA&ixlib=rb-4.1.0&q=85",
  meeting2:
    "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMHRyYW5zZm9ybWF0aW9uJTIwdGVhbSUyMG1lZXRpbmclMjBzdHJhdGVneXxlbnwwfHx8fDE3ODc3NjEyNzl8MA&ixlib=rb-4.1.0&q=85",
};

export const STATEMENT = [
  "Business is evolving.",
  "Technology is accelerating.",
  "Transformation is inevitable.",
];

export const CONVERGENCE = ["STRATEGY", "PEOPLE", "PROCESS", "TECHNOLOGY"];

export const CORE_THEMES = [
  "Change", "Kaizen", "Governance", "Business Transformation", "Digital Excellence",
  "Strategy", "People", "Process", "Technology", "Innovation", "Leadership",
  "Operational Excellence", "Sustainability", "Customer Delight",
];

export const CAPABILITIES = [
  { title: "Digital Platforms & Transformation", slug: "digital-transformation" },
  { title: "Products & Solutions", slug: "product-solution-consulting" },
  { title: "Technology Advisory", slug: "technology-advisory" },
  { title: "Virtual CIO / Technology Leadership", slug: "virtual-cio" },
  { title: "Strategy & Business Consulting", slug: "strategy-management-consulting" },
  { title: "Business Transformation", slug: "business-transformation" },
  { title: "Governance, Risk & Compliance", slug: "governance-risk-compliance" },
  { title: "Startup & Venture Advisory", slug: "startup-venture-advisory" },
  { title: "Programme & Project Management", slug: "program-project-management" },
];

export const SERVICES = [
  {
    slug: "digital-transformation",
    number: "01",
    title: "Digital Platforms & Transformation",
    tagline: "Platforms that move the business forward.",
    intro:
      "We design and deliver digital platforms — enterprise applications, cloud, data and mobility — tied to measurable business outcomes.",
    points: [
      "Digital strategy", "Enterprise applications", "Cloud platforms",
      "Data & analytics", "Mobility & web", "Digital operating models",
    ],
    image: IMAGES.arch2,
  },
  {
    slug: "product-solution-consulting",
    number: "02",
    title: "Products & Solutions",
    tagline: "From product idea to adopted solution.",
    intro:
      "We shape, build and implement products and solutions — SaaS, multi-tenant platforms, integration and rollout.",
    points: [
      "Product strategy", "Product development", "SaaS & multi-tenancy",
      "Integration", "Implementation", "Training & adoption",
    ],
    image: IMAGES.arch3,
  },
  {
    slug: "technology-advisory",
    number: "03",
    title: "Technology Advisory",
    tagline: "Senior technology judgement at the decision table.",
    intro:
      "Strategy, architecture and roadmaps — with implementation guided by an owner's discipline.",
    points: [
      "Technology strategy", "Enterprise architecture", "Technology assessment",
      "Roadmaps", "Infrastructure & cloud", "Implementation advisory",
    ],
    image: IMAGES.dataCenter,
  },
  {
    slug: "virtual-cio",
    number: "04",
    title: "Virtual CIO",
    tagline: "Technology leadership, on demand.",
    intro:
      "Senior technology leadership for SMBs and enterprises — without the cost of a full-time CIO.",
    points: [
      "Technology strategy", "IT & security policy", "Risk identification",
      "Vendor evaluation", "Infrastructure planning", "Project leadership",
    ],
    image: IMAGES.cabling,
    featured: true,
  },
  {
    slug: "strategy-management-consulting",
    number: "05",
    title: "Strategy & Business Consulting",
    tagline: "Direction, structure and measurable performance.",
    intro:
      "Strategy, operating models and performance frameworks that make ambition executable.",
    points: [
      "Business strategy", "Operating model", "Organisation design",
      "Performance & KPIs", "Growth strategy", "Competitive strategy",
    ],
    image: IMAGES.boardroom,
  },
  {
    slug: "business-transformation",
    number: "06",
    title: "Business Transformation",
    tagline: "From current constraints to future capability.",
    intro:
      "End-to-end transformation programmes — process, operating model and continuous improvement.",
    points: [
      "Transformation programmes", "Process re-engineering", "Change management",
      "Operational excellence", "Productivity", "Customer experience",
    ],
    image: IMAGES.meeting,
  },
  {
    slug: "governance-risk-compliance",
    number: "07",
    title: "Governance, Risk & Compliance",
    tagline: "Accountable, compliant, durable.",
    intro:
      "Governance models and proven frameworks that keep business and technology accountable.",
    points: [
      "IT governance", "Regulatory compliance", "Risk assessment",
      "Security frameworks", "COBIT & ITIL", "Policy & procedure",
    ],
    image: IMAGES.arch1,
  },
  {
    slug: "startup-venture-advisory",
    number: "08",
    title: "Startup & Venture Advisory",
    tagline: "From idea to market to scale.",
    intro:
      "We partner with founders from ideation and due diligence through go-to-market and scale.",
    points: [
      "Ideation & validation", "Due diligence", "Business models",
      "Go-to-market", "Partnerships", "Mentorship",
    ],
    image: IMAGES.meeting2,
  },
  {
    slug: "program-project-management",
    number: "09",
    title: "Programme & Project Management",
    tagline: "Delivery that holds under pressure.",
    intro:
      "Programmes and PMOs run with delivery governance, so complex initiatives land.",
    points: [
      "Programme management", "PMO", "Project planning",
      "Vendor management", "Service management", "Delivery governance",
    ],
    image: IMAGES.arch4,
  },
];

export const INDUSTRIES = [
  { name: "Government & Semi-Government", image: IMAGES.archWindows },
  { name: "Banking, Financial Services & Insurance", image: IMAGES.boardroom },
  { name: "Investment & Equity", image: IMAGES.arch2 },
  { name: "Telecom / ISP", image: IMAGES.cabling },
  { name: "ITES & BPO", image: IMAGES.dataCenter },
  { name: "Engineering & Construction", image: IMAGES.arch1 },
  { name: "Trading", image: IMAGES.arch3 },
  { name: "Retail", image: IMAGES.arch4 },
  { name: "CPG & FMCG", image: IMAGES.meeting },
  { name: "Franchising", image: IMAGES.meeting2 },
  { name: "Manufacturing", image: IMAGES.refinery2 },
  { name: "EPC", image: IMAGES.refinery },
  { name: "MEP", image: IMAGES.cabling },
  { name: "Oil & Gas", image: IMAGES.refinery },
  { name: "Energy & Utilities", image: IMAGES.refinery2 },
  { name: "Shipping", image: IMAGES.arch1 },
  { name: "Transport & Logistics", image: IMAGES.arch4 },
  { name: "Healthcare & Pharma", image: IMAGES.boardroom },
  { name: "Education & Training", image: IMAGES.meeting },
  { name: "Disaster Management & Security", image: IMAGES.dataCenter },
];

export const METAMORPHOSIS_STEPS = [
  { step: "Ideation", desc: "Shaping raw potential into a defensible idea." },
  { step: "Due Diligence", desc: "Rigorous evaluation of viability, risk and fit." },
  { step: "Validation", desc: "Testing assumptions against real conditions." },
  { step: "Proof of Concept", desc: "Demonstrating feasibility and value." },
  { step: "Product", desc: "Building a product that can stand on its own." },
  { step: "Market", desc: "Positioning and entering the right market." },
  { step: "Scale", desc: "Growing into enterprise value." },
];

export const METAMORPHOSIS_ECOSYSTEM = {
  actors: ["Industry", "Academia", "Government"],
  enablers: ["Research", "Proof of Concept", "Prototyping", "Policy", "Regulation", "Security"],
  ventureOffer: [
    "Enterprise resources", "Equity", "Infrastructure", "Mentorship",
    "Product development", "Business models", "Go-to-market",
  ],
};

export const INNOVATION_TECH = [
  { name: "Artificial Intelligence", desc: "Applied intelligence tied to defined business outcomes." },
  { name: "Robotics", desc: "Automation of physical and operational processes." },
  { name: "Internet of Things", desc: "Connected assets, data and real-time operations." },
  { name: "Augmented Reality", desc: "Immersive interfaces for training, service and design." },
  { name: "Embedded Systems", desc: "Intelligence at the edge of devices and machinery." },
  { name: "Cloud Computing", desc: "Elastic foundations for modern digital operating models." },
  { name: "Blockchain", desc: "Trust, provenance and distributed accountability." },
  { name: "Wearables", desc: "Data-driven products at the human interface." },
  { name: "Mobility", desc: "Business capability delivered anywhere it is needed." },
  { name: "Renewable Energy", desc: "Sustainable infrastructure and energy transition." },
  { name: "Analytics", desc: "Decisions grounded in evidence, not intuition." },
  { name: "Digital Assets", desc: "Emerging digital-asset and Bitcoin considerations, where appropriate." },
];

export const INNOVATION_FLOW = [
  "Use Case", "Business Case", "Deployment", "Maturity", "Governance", "Security", "Scale",
];

export const PHILOSOPHY = [
  {
    key: "Change",
    body: "REGERA helps organisations embrace and manage change — treating it as a capability, not an event.",
  },
  {
    key: "Kaizen",
    body: "Continuous improvement as an operating philosophy, compounding small gains into lasting advantage.",
  },
  {
    key: "Governance",
    body: "Aligning business, technology, risk, compliance and accountability across the enterprise.",
  },
  {
    key: "Transformation",
    body: "Moving organisations from current-state constraints to future-state capability.",
  },
  {
    key: "Digital Excellence",
    body: "Using technology in the context of business outcomes — never technology for its own sake.",
  },
];

export const EXECUTIVE_ATTRIBUTES = [
  "Professional expertise", "Practical experience", "Genuine talent", "Global accreditations",
  "World-class accomplishments", "Leadership", "Stakeholder management", "Business acquisition",
  "Operational excellence", "Revenue generation", "Financial prudence", "Compliance",
  "Governance", "Multicultural distributed teams", "Customer delight",
];

export const INSIGHT_CATEGORIES = [
  "All", "Business Transformation", "Technology Strategy", "Digital Excellence",
  "Governance", "AI & Emerging Technology", "Cybersecurity", "Leadership",
  "Entrepreneurship", "Industry Transformation",
];

export const HELP_OPTIONS = [
  "Technology Advisory", "Virtual CIO", "Digital Platforms", "Products & Solutions",
  "Business Consulting", "Transformation", "Governance, Risk & Compliance",
  "Startup & Venture Advisory", "Programme & Project Management", "Other",
];

export const CONTACT = {
  email: "info@regera.biz",
  phone: "+971 4 396 7000",
  phoneRaw: "+97143967000",
  web: "www.regera.biz",
  address: "P.O. Box 27267, Silicon Oasis, Dubai, UAE",
  city: "Dubai, United Arab Emirates",
};
